module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6SiPAN4t3oP7vCvFVkgLD7-2b5e1135022ca6455bbaf0144ff76beb.jpg";